import React from "react";
import { Tabs, Tab } from "react-bootstrap";

import { Page } from "ui/components";

import RiwayatManifest from './component/manifest';
import RiwayatAbsence from './component/absence';

const HistoryScreen = () => {
  const [tabKey, setTabKey] = React.useState("manifest");

  return (
    <Page hasFooter full title={`Riwayat`}>
      <Tabs
        defaultActiveKey="manifest"
        id="justify-tab-example"
        className="bg-white"
        justify
        onSelect={(e) => {
          setTabKey(e)}}
      >
        <Tab eventKey="manifest" title="Manifest">
          <RiwayatManifest tabKey={tabKey} />
        </Tab>
        <Tab eventKey="absence" title="Absence">
          <RiwayatAbsence tabKey={tabKey} />
        </Tab>
      </Tabs>
    </Page>
  );
};

export default HistoryScreen;
